import React from 'react';

const Slider = ({image}) => {
    
    return (
        <div className="w-full aspect-[16/6] overflow-hidden">
            <div className='bg-image-property animate__animated animate__pulse animate__slower' style={{backgroundImage: "url(" + image + ")"}}>
                <div className="w-full aspect-[16/6]">

                </div>
            </div>
        </div>
    )
}

export default Slider